import { Injectable } from "@angular/core";
import { DsmAdapter } from "@core/adapters/dsm.adapter";
import { ObjectValidator } from "@core/helper/object-validator";
import { ProductType } from "@core/models/api/dsm-types";
import { Observable } from "rxjs";

@Injectable({
  providedIn: 'root',
})
export class EvtAlertAdapter {
  constructor(
    private dsmAdapter: DsmAdapter
  ) {}

  fetchEvtAlerts(productType: ProductType, quoteId: string): Observable<EvtResponse> {
    return this.dsmAdapter.request(
      sanitizeEvtResponse,
      productType,
      'GET',
      `/quotes/${quoteId}/EVT-alert-messages`,
      'get-evt-alerts'
    );
  }

  updateEvtAgentReply(agentReply: EvtAgentReply, productType: ProductType, quoteId: string): Observable<EvtAgentReply> {
    const body = {
      ...agentReply
    };
    return this.dsmAdapter.request(
      sanitizeEvtAgentReply,
      productType,
      'PATCH',
      `/quotes/${quoteId}/EVT-alert-messages`,
      'patch-evt-alerts',
      { body }
    );
  }
}

export type EvtResponse = EvtAlertMessage[];
export interface EvtAlertMessage {
  ruleID: string;
  fixedID?: number;
  message: string;
}

export interface EvtAgentReply {
  ruleID: string;
  fixedID?: number;
  agentReply: string;
  message?: string;
}

export function sanitizeEvtResponse(input: unknown): EvtResponse {
  return ObjectValidator.sanitizeArray(input, sanitizeEvtAlertMessage);
}

export function sanitizeEvtAlertMessage(input: unknown): EvtAlertMessage {
  return ObjectValidator.forceSchema<EvtAlertMessage>(input, {
    ruleID: 'string',
    fixedID: 'number',
    message: 'string',
  });
}

export function sanitizeEvtAgentReply(input: unknown): EvtAgentReply {
  return ObjectValidator.forceSchema<EvtAgentReply>(input, {
    ruleID: 'string',
    fixedID: 'number',
    agentReply: 'string',
    message: 'string',
  });
}
